package navigation.home.crm

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.crm.domain.repository.CRMRepository
import com.essntl.features.crm.ui.CRMEvent
import com.essntl.features.crm.ui.CRMState
import com.essntl.features.crm.ui.CRMViewModel

class CRMScreenModel(
    crmRepository: CRMRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<CRMState>(CRMState()) {

    private val vm =
        CRMViewModel(
            crmRepository = crmRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: CRMEvent) = vm.onEvent(event)
}